<template lang="pug">
#modal-transfer-detail.modal.fade(tabindex='-1' role='dialog')
  .modal-dialog.modal-lg.modal-dialog-centered.my-0.modal-form
    .modal-content-outside
      .modal-content
        .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(data-dismiss="modal")
          .arrow-left
            i.fas.fa-chevron-left
          .modal-title.text-capitalize home
        .d-none.d-md-block.lg-close(data-dismiss='modal')
          i.far.fa-times-circle
        .modal-body
          .text-center
            .text-uppercase.modal-form-title transfer details
          //- .text-history.mt-3 You can view transfer history up to 90 days
          .tranfer-detail-wrap
            .d-lg-none
              template(v-if="!startRender")
                template(v-if="transferDetails.length > 0")
                  .d-flex.history-single(v-for="detail in transferDetails")
                    .flex-grow-1
                      .history-type {{detail.transfer_method}}
                      .history-type.mt-2 Balance Before
                      .history-type.mt-2 Balance After
                      .history-type.mt-2 Remark:
                        span.text-secondary {{detail.remark}}
                      .text-secondary.history-date {{$moment(detail.created_date).format("DD-MM-YYYY HH:mm")}} 
                    .history-right
                      .history-amount.text-right.text-success.font-weight-normal(v-if="$store.state.user.account.system_type === 'CASH'") {{ $numeral(detail.transfer_amount).format("0,0.00") }}
                      .history-amount.text-right.text-success.font-weight-normal(v-else) {{ $numeral(detail.settled_amount).format("0,0.00") }}
                      .text-secondary.history-date
                      .history-amount.text-right.text-success.font-weight-normal.mt-2 {{ $numeral(detail.account_balance_before).format("0,0.00") }}
                      .history-amount.text-right.text-success.font-weight-normal.mt-2 {{ $numeral(detail.account_balance_after).format("0,0.00") }}
                template(v-else)
                  .text-center.my-2 {{ $t('ui.no_record') }}
              template(v-else)
                .text-center.my-2
                  i.fas.fa-sync.fa-spin(style="color:white;")   
            .d-none.d-lg-block
              template(v-if="transferDetails.length > 0")
                .package-table.mb-0
                  .row.table-row
                    .col.text-left Date
                    .col Type
                    .col Amount
                    .col Balance Before
                    .col Balance After
                    .col remark                 
                  .row.table-row(v-for="detail in transferDetails")
                    .col.text-left {{$moment(detail.created_date).format("DD-MM-YYYY HH:mm")}}
                    .col {{detail.transfer_method}}
                    .col(v-if="$store.state.user.account.system_type === 'CASH'") {{ $numeral(detail.transfer_amount).format("0,0.00") }}
                    .col(v-else) {{ $numeral(detail.settled_amount).format("0,0.00") }}
                    .col {{ $numeral(detail.account_balance_before).format("0,0.00") }}
                    .col {{ $numeral(detail.account_balance_after).format("0,0.00") }}
                    .col {{detail.remark}}  
              template(v-else)
                .text-center.my-2 {{ $t('ui.no_record') }}    
                //- .text-center.my-2
        //- i.fas.fa-sync.fa-spin(style="color:white;")              
</template>
<script>
export default {
  data(){
    return{
      startRender: false
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    settlementDate(){
      return this.$store.getters.settlementDate
    },
    transferDetails(){
      return this.$store.getters.transferDetails;
    }
  },
  mounted(){
    let vm = this
    $('#modal-transfer-detail').on('shown.bs.modal', function (e) {
      // this.$nextTick(() => this.getSettlement());
      vm.getSettlement()
    })  
  },
  methods:{
    getSettlement(){
      if (this.sessionToken) {
        this.startRender = true
        let member_id = this.accountID
        let auth_token = this.sessionToken
        let working_date = this.settlementDate
        this.$store
          .dispatch("user/getMemberTransferDetails", { member_id, working_date, auth_token })
          .then(response => {
            if (response.success == true) {
              this.startRender = false
              this.$store
                .dispatch("user/sTransferDetails", response.data)
                .then(() => {
                  
                })
                .catch(err => console.log(err))
            } else {
              this.startRender = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.startRender = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    }
  }
}
</script>